{
    "LicenseManagement_Title": "Gestione delle licenze aziendali",
    "LicenseManagement_Heading_License": "Licenza - Squadre",
    "LicenseManagement_Heading_Quantity": "Quantità",
    "LicenseManagement_Essentials": "Elementi essenziali",
    "LicenseManagement_Essentials_MST": "Standard CXA",
    "LicenseManagement_Professional": "Professionale",
    "LicenseManagement_Professional_MST": "CXA Premium",
    "LicenseManagement_Enterprise": "Impresa",
    "LicenseManagement_Enterprise_MST": "CXA Advanced (storico)",
    "LicenseManagement_CallCentreAgent": "Agente di call center",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreSupervisor": "Supervisore del call center",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA avanzato",
    "LicenseManagement_Validation_Number": "Deve essere un numero valido",
    "LicenseManagement_Validation_Limit": "Supera il tetto della licenza ECM. Deve essere inferiore o uguale a {}",
    "LicenseManagement_Validation_Limit_Reached": "Supera il tetto massimo di licenze ECM. Non ci sono più licenze disponibili",
    "LicenseManagement_Validation_MAX_LIMIT": "Il numero supera il numero massimo consentito",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Il numero deve essere positivo",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "Integrazione CX",
    "LicenseManagement_Essentials_WBX": "Utente WxC",
    "LicenseManagement_Essentials_MSTB": "Utente storico",
    "LicenseManagement_Professional_WBX": "Professionale",
    "LicenseManagement_Professional_MSTB": "Utente in tempo reale",
    "LicenseManagement_Enterprise_WBX": "Imprese",
    "LicenseManagement_Enterprise_MSTB": "Imprese",
    "LicenseManagement_CallCentreAgent_WBX": "Agente WxC",
    "LicenseManagement_CallCentreAgent_MSTB": "Agente",
    "LicenseManagement_CallCentreSupervisor_WBX": "Supervisore WxC",
    "LicenseManagement_CallCentreSupervisor_MSTB": "Manager"
}